// VolcanoesAndRiftvalleys.js
import React, { useState } from 'react';
import styles from './VolcanoesAndRiftvalleys.module.css';
import { Container, Card } from 'react-bootstrap';
// Import your images here
import bannerImg from '../../../Assets/imagesssss/1/10008.jpg';
import vol1 from '../../../Assets/imagesssss/1/2.jpg';
import vol2 from '../../../Assets/imagesssss/1/2.jpg';
import vol3 from '../../../Assets/imagesssss/1/2.jpg';
import vol4 from '../../../Assets/imagesssss/1/2.jpg';
import vol5 from '../../../Assets/imagesssss/1/2.jpg';
import vol6 from '../../../Assets/imagesssss/1/2.jpg';
import rift1 from '../../../Assets/imagesssss/1/2.jpg';
import rift2 from '../../../Assets/imagesssss/1/2.jpg';
import rift3 from '../../../Assets/imagesssss/1/2.jpg';
import rift4 from '../../../Assets/imagesssss/1/2.jpg';
import rift5 from '../../../Assets/imagesssss/1/2.jpg';
import rift6 from '../../../Assets/imagesssss/1/2.jpg';
const VolcanoesAndRiftvalleys = () => {
  const [scrollPosition1, setScrollPosition1] = useState(0);
  const [scrollPosition2, setScrollPosition2] = useState(0);

  const volcanoes = [
    {
      id: 1,
      title: "Erta Ale Volcano",
      description: "Endless Horizons, Boundless Beauty—Welcome to Afar's Desert.",
      image: vol1
    },
    {
      id: 2,
      title: "Dallol Volcano",
      description: "Afar Desert: A Landscape Shaped by Heat, Wind, and Time.",
      image: vol2
    },
    {
      id: 3,
      title: "Ale Bagu",
      description: "Discover the Raw Power of Nature in Afar's Fiery Desert.",
      image: vol3
    },
    {
      id: 4,
      title: "Dubbre Volcano",
      description: "Embrace the Silence and Splendor of Afar's Vast Desert Plains.",
      image: vol4
    },
    {
      id: 5,
      title: "Kurub Volcano",
      description: "Where Earth’s Extremes Meet—The Unforgiving Afar Desert.",
      image: vol5
    },
    {
      id: 6,
      title: "Dama Ale",
      description: "Find Adventure Under the Blazing Sun in Afar’s Desert Wilderness.",
      image: vol6
    }
  ];

  const riftValleys = [
    {
      id: 7,
      title: "Danakil Depression",
      description: "Step Into the Depths of Time in Afar's Ancient Canyons.",
      image: rift1
    },
    {
      id: 8,
      title: "Afar Triangle",
      description: "Afar Canyons: Majestic, Rugged, and Ready to Be Explored.",
      image: rift2
    },
    {
      id: 9,
      title: "Lake Afdera",
      description: "Wander Through Canyon Walls Etched by Eons in Afar.",
      image: rift3
    },
    {
      id: 10,
      title: "Salt Plains",
      description: "Marvel at the Towering Cliffs of Afar’s Breathtaking Canyons.",
      image: rift4
    },
    {
      id: 11,
      title: "Awash Valley",
      description: "Unveil Layers of Earth’s History in Afar’s Scenic Canyons.",
      image: rift5
    },
    {
      id: 12,
      title: "Yangudi Rassa",
      description: "Feel the Awe of Nature’s Artistry in Afar’s Grand Canyons.",
      image: rift6
    }
  ];

  const handleScroll = (direction, row) => {
    const scrollAmount = 300;
    if (row === 1) {
      const maxScroll = volcanoes.length * 300;
      setScrollPosition1(prev => {
        const newPosition = direction === 'left' 
          ? prev - scrollAmount 
          : prev + scrollAmount;
        if (newPosition < 0) return 0;
        if (newPosition > maxScroll) return maxScroll;
        return newPosition;
      });
    } else {
      const maxScroll = riftValleys.length * 300;
      setScrollPosition2(prev => {
        const newPosition = direction === 'left' 
          ? prev - scrollAmount 
          : prev + scrollAmount;
        if (newPosition < 0) return 0;
        if (newPosition > maxScroll) return maxScroll;
        return newPosition;
      });
    }
  };

  return (
    
      <div className={styles.volcanoesPage}>
        <div 
          className={styles.banner} 
          style={{ backgroundImage: `url(${bannerImg})` }}
        >
          <h1>Desert and Canyons</h1>
          <p>Explore Afar’s Rugged Deserts and Timeless Canyons—Nature’s Grand Masterpiece.</p>
        </div>
  
        <div className={styles.carouselSection}>
          <h2>Desert and Canyons</h2>
          <Container className={styles.descriptionContainer}>
            <Card className={styles.descriptionCard}>
              <Card.Body>
                <Card.Text>
                  Afar’s desert and canyon landscapes showcase the raw, rugged beauty of the region...
                </Card.Text>
              </Card.Body>
            </Card>
          </Container>
  
          <div className={styles.carouselContainer}>
            <button 
              className={`${styles.scrollButton} ${styles.left}`} 
              onClick={() => handleScroll('left', 1)}
            >
              &#8249;
            </button>
            <div className={styles.cardsContainer}>
              <div 
                className={styles.cardsTrack} 
                style={{ transform: `translateX(-${scrollPosition1}px)` }}
              >
                {volcanoes.map(item => (
                  <div className={styles.card} key={item.id}>
                    <div className={styles.cardImage}>
                      <img src={item.image} alt={item.title} />
                    </div>
                    <div className={styles.cardContent}>
                      <h3>{item.title}</h3>
                      <p>{item.description}</p>
                    </div>
                  </div>
                ))}
              </div>
            </div>
            <button 
              className={`${styles.scrollButton} ${styles.right}`} 
              onClick={() => handleScroll('right', 1)}
            >
              &#8250;
            </button>
          </div>
  
          <h2>Desert and Canyons</h2>
          <Container className={styles.descriptionContainer}>
            <Card className={styles.descriptionCard}>
              <Card.Body>
                <Card.Text>
                  Afar's expansive desert and rugged canyons reveal the raw, untamed beauty of the region...
                </Card.Text>
              </Card.Body>
            </Card>
          </Container>
  
          <div className={styles.carouselContainer}>
            <button 
              className={`${styles.scrollButton} ${styles.left}`} 
              onClick={() => handleScroll('left', 2)}
            >
              &#8249;
            </button>
            <div className={styles.cardsContainer}>
              <div 
                className={styles.cardsTrack} 
                style={{ transform: `translateX(-${scrollPosition2}px)` }}
              >
                {riftValleys.map(item => (
                  <div className={styles.card} key={item.id}>
                    <div className={styles.cardImage}>
                      <img src={item.image} alt={item.title} />
                    </div>
                    <div className={styles.cardContent}>
                      <h3>{item.title}</h3>
                      <p>{item.description}</p>
                    </div>
                  </div>
                ))}
              </div>
            </div>
            <button 
              className={`${styles.scrollButton} ${styles.right}`} 
              onClick={() => handleScroll('right', 2)}
            >
              &#8250;
            </button>
          </div>
        </div>
      </div>
  );
};

export default VolcanoesAndRiftvalleys;